import { useQuery, useQueryClient } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getFiles } from "../services/files";

export function useGetFiles(path: string, options?: { enabled?: boolean }) {
  const queryClient = useQueryClient();

  const queryKey = ["files", path];

  const query = useQuery({
    queryKey,
    queryFn: () => getFiles(path),
    enabled: options?.enabled ?? true,
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });

  return {
    ...query,
    invalidate: () => queryClient.invalidateQueries({ queryKey }),
  };
}
